export default "__VITE_ASSET__CrA45fWo__"